import React from 'react';
import { StyledBox } from 'views/membership-module/MembershipLandingView/components/HowItWorksSection/HowItWorksSection.styles';
import { useTranslation } from 'next-i18next';
import {
  Typography, Box, Button, Grid,
} from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import { ImgBox, SectionTitleWithDesc } from 'views/common/components';
import ScrollTo from 'lib/utils/ScrollTo';
import { SECTION_ID } from 'views/membership-module/MembershipLandingView/utils/constants';

const HowItWorksSection = (props) => {
  const { darkMode, membershipName } = props;
  const { t } = useTranslation('fe_er_membership_landing_page');
  const handleStartJourneyClick = () => {
    ScrollTo(SECTION_ID.COMPARE_PLAN);
  };
  const howWorksItems = [
    {
      title: membershipName || t('fe_er_membership_landing_page:join_club'),
      desc: t('fe_er_membership_landing_page:choose_plan'),
      lightSrc: '/imgs/howItWork/HowItWorksImgLight1.png',
      darkSrc: '/imgs/howItWork/HowItWorksImgDark1.png',
      name: 'How It Works',
    },
    {
      title: t('fe_er_membership_landing_page:book_ride'),
      desc: t('fe_er_membership_landing_page:come_back'),
      lightSrc: '/imgs/howItWork/HowItWorksImgLight2.png',
      darkSrc: '/imgs/howItWork/HowItWorksImgDark2.png',
      name: 'How It Works',
    },
    {
      title: t('fe_er_membership_landing_page:apply_rental_credit'),
      desc: t('fe_er_membership_landing_page:on_our_checkout'),
      lightSrc: '/imgs/howItWork/HowItWorksImgLight3.png',
      darkSrc: '/imgs/howItWork/HowItWorksImgDark3.png',
      name: 'How It Works',
    },
    {
      title: t('fe_er_membership_landing_page:enjoy_ride'),
      desc: (
        <Box mt={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleStartJourneyClick}>
            {t('fe_er_membership_landing_page:enjoy_journey')}
          </Button>
        </Box>
      ),
      lightSrc: '/imgs/howItWork/HowItWorksImgLight4.png',
      darkSrc: '/imgs/howItWork/HowItWorksImgDark4.png',
      name: 'How It Works',
    },
  ];
  return (
    <StyledBox className={darkMode && 'HIWSDark'}>
      <SectionTitleWithDesc
        title={t('fe_er_membership_landing_page:how_works')}
        component="h2"
        className="HIWMainTitle"
      />
      <Grid container spacing={2.5}>
        {howWorksItems.map((item) => (
          <Grid item sm={12} md={6} lg={3} key={item.title}>
            <Box className="HIWitem">
              <ImgBox
                imgHeight={130}
                imgObjectFit="contain"
                image={{
                  src: darkMode ? item.darkSrc : item.lightSrc,
                  alt: item.name,
                }}
              />
              <Box mt={1.5}>
                <Typography500
                  variant="h5"
                  component="p"
                  mb={1}
                  className="HIWTitle">
                  {item.title}
                </Typography500>
                <Typography variant="body2" component="p" className="HIWdesc">
                  {item.desc}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Typography variant="caption" component="p" pt={3}>
        {t('fe_er_membership_landing_page:applied_towards')}
      </Typography>
    </StyledBox>
  );
};

export { HowItWorksSection };
